/**
 * Valeurs Icons Scroll Behavior
 * Makes icons scroll within their sections
 */

export function initValeursIcons() {
  const TRIGGER_OFFSET = 8 * 16; // 8rem
  const scrollContainer = document.querySelector('[data-valeurs-content]');
  const sections = document.querySelectorAll('[data-valeur-section]');

  if (!scrollContainer) return;

  function updateIcons() {
    // Get the container's top position (our reference point)
    const containerRect = scrollContainer.getBoundingClientRect();

    sections.forEach((section) => {
      const icon = section.querySelector('[data-valeur-icon]');
      const rect = section.getBoundingClientRect();

      // Position relative to the scroll container, not the viewport
      const sectionTopInContainer = rect.top - containerRect.top;
      const sectionHeight = rect.height;
      const iconHeight = icon.offsetHeight;
      const maxTravel = sectionHeight - iconHeight;

      // Progress: how far past the trigger offset inside the container
      const progress = (TRIGGER_OFFSET - sectionTopInContainer) / sectionHeight;
      const clamped = Math.max(0, Math.min(1, progress));

      icon.style.transform = `translateY(${clamped * maxTravel}px)`;
    });
  }

  // Listen to the INNER scroll container, not window
  let ticking = false;
  scrollContainer.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        updateIcons();
        ticking = false;
      });
      ticking = true;
    }
  });

  updateIcons();
}